import { useState } from 'react'
import { Avatar, Tooltip, theme } from 'antd'
import { observer } from 'mobx-react-lite'
import { useStore } from '../../Stores'
import { Reaction } from '../../Contracts'

const AVATAR_SIZE = 16

interface MessageReactionsProps {
  reactions: Reaction[]
  messageId: string
}

const MessageReactions = observer(({ reactions, messageId }: MessageReactionsProps) => {
  const { messageStore, userStore } = useStore()
  const { token } = theme.useToken()
  const [hoveredEmoji, setHoveredEmoji] = useState<string | null>(null)

  if (reactions.length === 0) return null

  return (
    <>
      {reactions.map((reaction) => {
        const iReacted = reaction.userIds.includes(userStore.currentUserId)
        const isHovered = hoveredEmoji === reaction.emoji
        const pillBg = iReacted ? token.colorPrimaryBg : token.colorFillTertiary
        return (
          <div
            key={reaction.emoji}
            onClick={() => messageStore.toggleReaction(messageId, reaction.emoji)}
            onMouseEnter={() => setHoveredEmoji(reaction.emoji)}
            onMouseLeave={() => setHoveredEmoji(null)}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 3,
              padding: '2px 6px',
              borderRadius: 10,
              cursor: 'pointer',
              fontSize: 14,
              background: pillBg,
              border: `1px solid ${iReacted ? token.colorPrimaryBorder : token.colorBorderSecondary}`,
              opacity: isHovered ? 0.8 : 1,
              transition: 'background 0.15s, border-color 0.15s, opacity 0.15s',
            }}
          >
            <span>{reaction.emoji}</span>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              {reaction.userIds.map((userId, i) => {
                const user = userStore.getById(userId)
                const name = user ? `${user.firstName} ${user.lastName}` : 'Невідомий'
                return (
                  <Tooltip key={userId} title={name}>
                    {user?.avatarUrl ? (
                      <Avatar
                        src={user.avatarUrl}
                        size={AVATAR_SIZE}
                        style={{
                          marginLeft: i > 0 ? -2 : 0,
                          border: `1px solid ${pillBg}`,
                        }}
                      />
                    ) : (
                      // Літерний фолбек — власне коло: antd Avatar на 16px
                      // авто-масштабує літеру transform'ом і центрує криво
                      <span
                        style={{
                          width: AVATAR_SIZE,
                          height: AVATAR_SIZE,
                          borderRadius: '50%',
                          background: token.colorTextQuaternary,
                          color: token.colorBgContainer,
                          fontSize: 9,
                          fontWeight: 600,
                          display: 'inline-flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          flexShrink: 0,
                          boxSizing: 'border-box',
                          marginLeft: i > 0 ? -2 : 0,
                          border: `1px solid ${pillBg}`,
                          userSelect: 'none',
                        }}
                      >
                        {(user?.firstName.charAt(0) ?? '?').toUpperCase()}
                      </span>
                    )}
                  </Tooltip>
                )
              })}
            </div>
          </div>
        )
      })}
    </>
  )
})

export default MessageReactions
